import { API_ROOT } from './constants';
import { normalize } from 'normalizr';
//import history from '../modules/core/history';
//import * as AuthActionTypes from '../modules/auth/auth.actionTypes';

// Fetches an API response and normalizes the result JSON according to schema.
// This makes every API response have the same shape, regardless of how nested it was.
const callApi = (endpoint, schema, requestInit = null, token = null, authFailHandling = false) => {
  const fullUrl = endpoint.indexOf(API_ROOT) === -1 ? API_ROOT + endpoint : endpoint;
  requestInit = requestInit || {};
  if(token) {
    requestInit.headers = requestInit.headers || new Headers();
    if(typeof requestInit.headers.append === 'function') {
      requestInit.headers.append('authtoken', `${token}`);
    } else {
      requestInit.headers['authtoken'] = `${token}`;
    }
  }

  const request = new Request(fullUrl, requestInit);
  
  return fetch(request)
    .then(response => {
      if(response.status === 403 && !authFailHandling) {
        return Promise.reject('not authorized');
      }
      return response.json().then(json => {
        if (!response.ok) {
          return Promise.reject(json);
        }
        if(!schema) {
          return Object.assign({},
            json,
            { method: request.method, status: response.ok ? 'ok' : 'error' }
          );
        }
        return Object.assign({},
          normalize(json, schema),
          { method: request.method, status: response.ok ? 'ok' : 'error' }
        );
      }).catch((error) => {
        if(response.status === 204) {
          return {};
        }
        return Promise.reject(error);
      }); 
    });
};

// Action key that carries API call info interpreted by this Redux middleware.
export const CALL_API = 'Call API';

// A Redux middleware that interprets actions with CALL_API info specified.
// Performs the call and promises when such actions are dispatched.
export default store => next => action => {
  const callAPI = action[CALL_API];
  if (typeof callAPI === 'undefined') {
    return next(action);
  }

  let { endpoint } = callAPI;
  const { schema, types, requestInit, authorization, authFailHandling = false } = callAPI;

  if (typeof endpoint === 'function') {
    endpoint = endpoint(store.getState());
  }

  if (typeof endpoint !== 'string') {
    throw new Error('Specify a string endpoint URL.');
  }
  /*
  if (!schema) {
    throw new Error('Specify one of the exported Schemas.');
  }
  */
  if (!Array.isArray(types) || types.length !== 3) {
    throw new Error('Expected an array of three action types.');
  }
  if (!Array.isArray(types)) {
    throw new Error('Expected an array of action types.');
  }
  if (!types.every(type => typeof type === 'string')) {
    throw new Error('Expected action types to be strings.');
  }

  const actionWith = data => {
    const finalAction = Object.assign({}, action, data);
    delete finalAction[CALL_API];
    return finalAction;
  };

  const [requestType, successType, failureType] = types;
  next(actionWith({ type: requestType }));

  const auth = store.getState().auth;
  const token = authorization
    ? auth && auth.authToken
      ? auth.authToken
      : localStorage.getItem('cmore-sisapiiri-token')
    : null;
  const payload = action.payload;

  return callApi(endpoint, schema, requestInit, token, authFailHandling).then(
    response => next(actionWith({
      response,
      type: successType,
      payload,
    })),
    error => {
      /*
      //TODO Move to reducer?
      if(error === 'not authorized') {
        localStorage.removeItem('cmore-sisapiiri-token');
        next(actionWith({
          type: AuthActionTypes.LOGOUT_SUCCESS,
        }));
        history.push('/unauthorized');
        return;
      }
      */
      return next(actionWith({
        type: failureType,
        error: error || 'Something bad happened',
        payload,
      }));
    }
  );
};


// WEBPACK FOOTER //
// ./src/api/index.js